<template>
    <div class="sidebar-wrapper">
        <div class="sidebar">
            <a class="toggle-menu" @click="toggleMenu">
                <i class="fa" :class="{'fa-angle-double-left' : expand, 'fa-angle-double-right' : !expand}"></i>
            </a>
            <div class="panel panel-default panel-sidebar" v-show="expand">
                <div class="panel-body">
                    <h2><span>{{parentMenu.name}}</span></h2>
                    <hr>
                    <ul class="menu">
                        <li class="level1"
                            v-for="l1 in menus"
                            v-if="checkFeature(l1.authCode) && l1.name"
                            :class="{expand:l1.expanded, active:l1.active}">
                            <router-link v-if="l1.route" :to="l1.route" @click.native="itemClick(l1)">
                                <i class="icon" :class="iconClass(l1)"></i>
                                <span>{{l1.name}}</span>
                                <i class="fa" :class="faClass(l1)"></i>
                            </router-link>
                            <a v-else @click="itemClick(l1)" :href="href(l1)" :target="l1.target">
                                <i class="icon" :class="iconClass(l1)"></i>
                                <span>{{l1.name}}</span>
                                <i class="fa" :class="faClass(l1)"></i>
                            </a>
                            <!-- level2 -->
                            <ul class="level2" v-if="l1.expanded">
                                <li v-for="l2 in l1.children"
                                    v-if="checkFeature(l2.authCode)"
                                    :class="{active:l2.active}"
                                    @click="itemClick(l2)">
                                    <router-link v-if="l2.route" :to="l2.route">
                                        <i class="ico-dot fa fa-circle-thin"></i>
                                        <span>{{l2.name}}</span>
                                        <img class="imgLocation" v-if="l2.hot" src="../assets/images/sidebar/hot.png">
                                    </router-link>
                                    <a v-else :href="href(l2)" :target="l2.target">
                                        <i class="ico-dot fa fa-circle-thin"></i>
                                        <span>{{l2.name}}</span>
                                        <img class="imgLocation" v-if="l2.hot" src="../assets/images/sidebar/hot.png">
                                    </a>
                                </li>
                            </ul>
                        </li>
                    </ul>
                </div>
            </div>
        </div>
    </div>
</template>
<style lang="scss" rel="stylesheet/scss" scoped>
    .shrink-slidebar{
        .sidebar-wrapper .sidebar {
            .toggle-menu{
                right: -17px;
                border: 1px solid #c7e0ef;
                border-left: none;
                border-radius: 0 3px 3px 0;
            }
        }
    }
    .sidebar-wrapper {
        height:100%;
        .sidebar {
            height:100%;
            width: 199px;
            //background: #fff;
            position: relative;
            -webkit-font-smoothing: antialiased;
            .toggle-menu{
                line-height: 35px;
                cursor: pointer;
                position: absolute;
                top: 21px;
                right: -1px;
                overflow: hidden;
                width: 16px;
                height: 36px;
                border: 1px solid #c7e0ef;
                border-right: none;
                border-radius: 3px 0 0 3px;
                z-index: 100;
                background: #f7fdfd;
                text-align: center;
                color: gray;
            }
            .panel {
                height:100%;
                border:none;
                border-radius: 0;
                background-color: #f0f6f6;
                border-right: 1px solid #cedfea;
                margin-bottom:0;
                > .panel-heading {
                    color: #fff;
                    background-color: #009be3;
                    border-color: #ddd;
                    border-radius: 0;
                    font-size: 15px;
                }
                > .panel-body {
                    padding: 0;
                    h2{
                        &:before{
                            content: '';
                            width: 0;
                            height: 100%;
                            display: inline-block;
                            vertical-align: middle;
                        }
                        font-size: 22px;
                        font-weight: 400;
                        line-height: 1.2;
                        display: block;
                        padding: 0 20px;
                        color: #171d25;
                        height: 62px;
                        margin:0;
                        span{
                            display: inline-block;
                            vertical-align: middle;
                        }
                    }
                    hr{
                        width: 156px;
                        height: 0;
                        margin: 0 auto 15px;
                        border: none;
                        border-top: 1px solid #cadbe6;
                        border-bottom: 1px solid #f8fbfb;
                    }

                    ul {
                        > li {
                            //border-bottom: 1px solid #ddd;
                            &.level1 {
                                > a {
                                    .icon {
                                        width:40px;
                                        height: 40px;
                                        display: inline-block;
                                        position: absolute;
                                        background: no-repeat center;
                                        background-size: 50%;
                                    }
                                }
                            }
                            &.level1.active {
                                > a {

                                }
                            }
                            &.level1.expand {
                                //background-color: #f2faff;
                            }
                        }
                    }
                }
            }
        }
        .sidebar ul, .sidebar ul li {
            margin: 0;
            padding: 0;
            list-style: none;
        }
        .sidebar ul.menu{
            font-size: 14px;
            line-height: 35px;
            overflow: auto;
            position: absolute;
            width: 100%;
            top: 75px;
            bottom: 0;
            padding-top: 15px;
        }

        .sidebar ul li a {
            background: no-repeat 10px center;
        }

        .sidebar ul li {

            &.active {
                &.home {
                    > a {
                        color: #fff;
                        border: none;
                        right: 0;
                        background-color: #f65b5c;
                    }
                }
            }

            &.active {
                > a {
                    color: #2277da;
                    -webkit-font-smoothing: antialiased;
                }
                &.expand{
                    > a {
                        color: #586376;
                        &:hover {
                            color: #2277da;
                        }
                    }
                }
            }

            > a:hover {
                color: #2277da;
                background-color: #d5e2ef;
            }
            > a:hover, > a:active, > a:focus{
                text-decoration: initial;
            }

            > a {
                position: relative;
            }
        }

        .sidebar ul li > a {
            width: 100%;
            height: 37px;
            line-height: 37px;
            font-size: 14px;
            font-weight: 700;
            color: #586376;
            display: inline-block;
            span{
                margin-left: 25px;
            }
        }

        .sidebar ul li.level1 > a > i.fa {
            line-height: 37px;
            position: absolute;
            top: -1px;
            right: 12px;
        }
        .sidebar ul.level2 li {
            > a{
                color: gray;
                .ico-dot{
                    display: inline-block;
                    margin: 0 5px 0 29px;
                    font-size:1px;
                }
                span{
                    margin-left: 0;
                }
            }
            &.active {
                > a {
                    color: #2277da;
                    -webkit-font-smoothing: antialiased;
                }
            }

            > a:hover {
                color: #2277da;
                background-color: #d5e2ef;
            }
        }
    }
</style>
<script type="text/ecmascript-6">
    import menus from './menus'

    var reset = (menus) => {
//        menus.forEach(v => {
//            v.active = false;
//
//            v.expanded = v.expanded === undefined ? true : v.expanded;
//            if (v.children) {
//                v.children.forEach(c => {
//                    c.active = false;
//                    c.expanded = c.expanded === undefined ? true : c.expanded;
//                });
//            }
//        });
    };

    reset(menus);

    export default {
        data(){
            return {
                menus : menus.slideMenus,
                expand : true
            }
        },
        components: {},
        methods: {
            toggleMenu(){
                this.expand = !this.expand;
                this.$parent.shrinkSlidebar = !this.expand;
            },
            iconClass(item){
                return `icon-${item.icon}`
            },
            faClass(item){
                return {
                    'fa-angle-down' : item.children && item.children.length && !item.expanded,
                    'fa-angle-up' : item.children && item.children.length && item.expanded,
                    'fa-angle-right' : (!item.children || !item.children.length) && (item.url || item.route),
                }
            },
            href(item){
                return item.url ? item.url : 'javascript:'
            },
            itemClick(item){
                reset(this.menus);
                item.active = true;
                item.expanded = !item.expanded;
            }
        },
        computed: {
            parentMenu(){
                var menu = this.menus[0];
                if(menu){
                    return menu.parent
                }
                return {}
            }
        }
    }
</script>



// WEBPACK FOOTER //
// src/layout/SideBar.vue